import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { analytics } from "@/lib/analytics";

export function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-background"
    >
      {/* Subtle background accent */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-muted/30 to-transparent" />
        <div className="absolute bottom-0 left-1/4 w-px h-1/2 bg-gradient-to-t from-border to-transparent" />
        <div className="absolute top-1/4 right-1/4 w-px h-1/3 bg-gradient-to-b from-border to-transparent" />
      </div>

      <div className="container mx-auto px-4 pt-32 pb-40 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Above-the-fold text renders immediately (no opacity:0 entry)
              so Speed Index isn't inflated by staggered fade-ins. */}
          <div className="mb-12">
            <span className="inline-block text-xs tracking-wide-elegant uppercase text-muted-foreground border-b border-foreground/20 pb-2">
              Trading & E-Commerce Excellence
            </span>
          </div>

          {/* Main Headline — LCP element, paints on first frame. */}
          <h1
            className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-foreground leading-[1.1] mb-8 font-medium"
          >
            Your Partner in
            <br />
            <span className="text-muted-foreground">Trading & E-Commerce</span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-14 leading-relaxed font-light">
            <strong className="text-foreground font-medium">SAILKHA TRADE</strong> — India's trusted trading company delivering 
            quality industrial and construction products through B2B sourcing, wholesale trading, and e-commerce solutions.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button 
              size="lg" 
              className="min-w-[200px] bg-foreground text-background hover:bg-foreground/90 rounded-none h-14 px-8 text-sm tracking-wide-elegant uppercase font-medium" 
              asChild
            >
              <a href="#contact" onClick={() => analytics.quoteClick("hero")} className="flex items-center gap-3">
                Get a Quote
                <ArrowRight className="w-4 h-4" />
              </a>
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="min-w-[200px] rounded-none h-14 px-8 text-sm tracking-wide-elegant uppercase font-medium border-foreground/20 hover:bg-muted" 
              asChild
            >
              <a href="#services">
                Our Services
              </a>
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="absolute bottom-12 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="flex flex-col items-center gap-3"
        >
          <span className="text-[10px] tracking-wide-elegant uppercase text-muted-foreground">Scroll</span>
          <div className="w-px h-12 bg-gradient-to-b from-foreground to-transparent" />
        </motion.div>
      </motion.div>
    </section>
  );
}
